import profile from '../../fields/other/profile';

export const QUERY_GET_PROFILE = /* GraphQL */ `
	query($id: String!) {
		getProfile(id: $id) {
            ${profile}
		}
	}
`;
